import React, {Fragment, PureComponent} from 'react';
import './index.scss';
import {InputItem, Button, Toast, WingBlank, WhiteSpace} from 'antd-mobile';
import {
    bindPhoneActionResult,
    sendMessageActionResult,
    wxLogin,
    isRegister
} from './../store/actionCreators';
import {connect} from 'react-redux';
import history from './../../../utils/history';

class Bind extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
        }
        this.init();
    }

    init() {
        this.bindEvent();
    }

    bindEvent() {
        this.handleBindPhone = this.handleBindPhone.bind(this);
        this.handleSendCode = this.handleSendCode.bind(this);
    }


    async handleBindPhone() {
        var userInfo = Storage.Base.getInstance().get('_loginTk');
        if (userInfo === null) {
            history.push('./login');
            return;
        }
        const data = {
            type: '2',
            phone: this.phoneRef.state.value,
            smsCode: this.validateRef.state.value,
            token: userInfo,
        };
        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }
        if (!data.smsCode) {
            Toast.info("请输入手机验证码！")
            return;
        }
        const result = await this.props.handleBindPhone(data);
        if (result.status === 200) {
            Storage.Base.getInstance().set("register", true);
            Toast.info("手机号绑定成功！")
            setTimeout(() => {
                history.push('./home?tab=Home');
            }, 1000);
        } else {
            Toast.info("绑定失败,请刷新重试.");
        }
    }

    async handleSendCode() {
        var time = 60;
        var that = this;
        if (this.state.sendStatus === 1) {
            return;
        }

        const data = {
            type: '3',
            smsType: "1",
            phone: this.phoneRef.state.value
        };

        data.phone = data.phone.replace(/\s+/g, "");

        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }

        const result = await this.props.handleSendCode(data);

        console.log("result", result)
        if (result.status === 200) {
            Toast.success("发送成功");
        } else {
            Toast.fail('网络异常', 1);
        }

        setInterval(function () {
            if (time <= 0) {
                that.setState({
                    sendMessage: '发送验证码',
                })
            }
            else {
                that.setState({
                    sendMessage: time + "s后重新获取",
                    sendStatus: 1
                });
                time--;
            }
        }, 1000);
    }


    HandleCancelBind() {
        history.push('./home?tab=Home');
    }

    render() {
        const {sendMessage} = this.state;

        return (
            <Fragment>
                <div className="art-user-login-wrapper">
                    <WingBlank>
                        <div className="art-user-login">
                            <InputItem
                                clear
                                ref={el => this.phoneRef = el}
                                placeholder="手机号码"
                                maxLength="11"
                                extra={sendMessage}
                                onExtraClick={this.handleSendCode}
                            >
                            </InputItem>

                            <InputItem
                                clear
                                ref={el => this.validateRef = el}
                                placeholder="验证码">
                            </InputItem>
                            <WhiteSpace size="lg"/>
                            <WhiteSpace size="lg"/>
                            <WhiteSpace size="lg"/>
                            <WhiteSpace size="lg"/>
                            <Button type="primary" onClick={this.handleBindPhone}
                                    style={{lineHeight: '50px'}}>绑定手机号</Button>
                        </div>
                    </WingBlank>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        bindPhone: state.bindPhone
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleBindPhone: data => dispatch(bindPhoneActionResult(data)),
        handleSendCode: data => dispatch(sendMessageActionResult(data)),
        handleWxLogin: (params) => dispatch(wxLogin(params)),
        isRegister: (params) => dispatch(isRegister(params))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Bind);